// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lsn-form-sidebar-panel {
  background-color: var(--main-bg-color-lighter);
  padding: 0.5rem 0.7rem;
  border-radius: var(--main-border-radius);
  border: var(--main-border-width) solid var(--main-border-color);
}
.lsn-form-sidebar-panel .toggle-header {
  display: flex;
  width: 100%;
}
.lsn-form-sidebar-panel .toggle-header.expanded {
  margin-bottom: 1rem;
}
.lsn-form-sidebar-panel .lsn-filter-tag {
  padding-left: 0.3rem;
  display: flex;
  align-items: center;
}
.lsn-form-sidebar-panel .lsn-filter-tag-accepted {
  border-left: 0.3rem solid var(--main-eval-accepted);
}
.lsn-form-sidebar-panel .lsn-filter-tag-requested {
  border-left: 0.3rem solid var(--main-eval-requested);
}
.lsn-form-sidebar-panel .lsn-filter-tag-completed {
  border-left: 0.3rem solid var(--main-eval-completed);
}
.lsn-form-sidebar-panel .lsn-filter-tag-declined {
  border-left: 0.3rem solid var(--main-eval-declined);
}
.lsn-form-sidebar-panel .lsn-filter-tag-expired {
  border-left: 0.3rem solid var(--main-eval-expired);
}
.lsn-form-sidebar-panel .lsn-filter-tag .badge-count {
  margin-left: 0.2rem;
  vertical-align: super;
  margin-top: -0.2rem;
}
.lsn-form-sidebar-panel .lsn-search .search-icon {
  position: absolute;
  top: 0;
  transform: translateY(50%) translateX(50%);
}
.lsn-form-sidebar-panel .lsn-search input {
  padding-left: 1.5rem;
}
.lsn-form-sidebar-panel .lsn-search .lsn-form-control-error-message {
  white-space: unset;
  position: static !important;
}
@media (max-width: 840px) {
  .lsn-form-sidebar-panel .toggle-header.collapsed ~ * {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/Sidebar/Sidebar.less"],"names":[],"mappings":"AAAA;EACE,8CAAA;EACA,sBAAA;EACA,wCAAA;EACA,+DAAA;AACF;AALA;EAOI,aAAA;EACA,WAAA;AACJ;AACI;EACE,mBAAA;AACN;AAZA;EAgBI,oBAAA;EACA,aAAA;EACA,mBAAA;AADJ;AAGI;EACE,mDAAA;AADN;AAII;EACE,oDAAA;AAFN;AAKI;EACE,oDAAA;AAHN;AAMI;EACE,mDAAA;AAJN;AAOI;EACE,kDAAA;AALN;AAhCA;EAyCM,mBAAA;EACA,qBAAA;EACA,mBAAA;AANN;AArCA;EAiDM,kBAAA;EACA,MAAA;EACA,0CAAA;AATN;AA1CA;EAuDM,oBAAA;AAVN;AA7CA;EA2DM,kBAAA;EACA,2BAAA;AAXN;AAeE;EAAA;IAEI,aAAA;EAbJ;AACF","sourcesContent":[".lsn-form-sidebar-panel {\n  background-color: var(--main-bg-color-lighter);\n  padding: .5rem .7rem;\n  border-radius: var(--main-border-radius);\n  border: var(--main-border-width) solid var(--main-border-color);\n\n  .toggle-header {\n    display: flex;\n    width: 100%;\n\n    &.expanded {\n      margin-bottom: 1rem;\n    }\n  }\n\n  .lsn-filter-tag {\n    padding-left: .3rem;\n    display: flex;\n    align-items: center;\n\n    &-accepted {\n      border-left: .3rem solid var(--main-eval-accepted);\n    }\n\n    &-requested {\n      border-left: .3rem solid var(--main-eval-requested);\n    }\n\n    &-completed {\n      border-left: .3rem solid var(--main-eval-completed);\n    }\n\n    &-declined {\n      border-left: .3rem solid var(--main-eval-declined);\n    }\n\n    &-expired {\n      border-left: .3rem solid var(--main-eval-expired);\n    }\n\n    .badge-count {\n      margin-left: .2rem;\n      vertical-align: super;\n      margin-top: -.2rem;\n    }\n  }\n\n  .lsn-search {\n    .search-icon {\n      position: absolute;\n      top: 0;\n      transform: translateY(50%) translateX(50%);\n    }\n\n    input {\n      padding-left: 1.5rem;\n    }\n\n    .lsn-form-control-error-message {\n      white-space: unset;\n      position: static !important;\n    }\n  }\n\n  @media (max-width: 840px) {\n    .toggle-header.collapsed~* {\n      display: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
